<template>
  <div>
    <!-- 登录标题 -->
    <div class="loginTitle">
      <div class="w">
        <div class="loginTitle-logo fl">
          <img src="https://www.myfund.com/images/zhx_logo.png" alt="" class="logo">
        </div>
        <div class="loginTitle-phone fr">
          <p>咨询热线：<span>400-818-8000</span> </p>
        </div>
      </div>
    </div>
    <!-- 登录内容 -->
    <div class="loginCon">
      <div class="loginCon-box w clearfix">
        <div class="loginCon-box-left fl">
          <div class="loginCon-box-tit">理财顾问管理平台</div>
          <img style="margin:31px 0 58px 0" src="../../assets/images/login5.png" alt="">
          <ul class="loginCon-box-ul clearfix">
            <li>
              <img src="../../assets/images/login4.png" alt="">
              <span class="fb">客户信息</span><span>管理</span>
            </li>
            <li>
              <img src="../../assets/images/login6.png" alt="">
              <span class="fb">佣金实时</span><span>预览</span>
            </li>
            <li>
              <img src="../../assets/images/login7.png" alt="">
              <span class="fb">资产配置</span><span>跟踪</span>
            </li>
          </ul>
        </div>
        <div class="loginCon-box-right fl">
          <div class="loginCon-box-loginTit">
            <span :class="{'active':!manage}" @click="manage = false">顾问登录</span>
            <span></span>
            <span :class="{'active':manage}" @click="manage = true">管理员登录</span>
          </div>
          <el-form :model="loginForm" ref="loginFormRef" :rules="loginFormRules" class="demo-ruleForm">
            <el-form-item prop="code" :error="phoneErrorMsg">
              <el-input v-model="loginForm.code" ref="loginRef" placeholder="请输入管理账号/手机号" @keyup.enter.native="LoginEnter" style="border-color:#ccc;">
                <img slot="prefix" src="../../assets/images/login3.png"></img>
              </el-input>
            </el-form-item>
            <el-form-item prop="pass" :error="passErrorMsg">
              <el-input v-model="loginForm.pass" ref="psdRef" @keyup.enter.native="PwdEnter" type="password" placeholder="请输入登录密码" show-password>
                <img slot="prefix" src="../../assets/images/login2.png"></img>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="login" @click="login" style="margin:22px 0 0;">登录</el-button>
              <a class="fl aColor" href="https://www.myfund.com/advisorProcess.html?index=10" target="_blank">申请成为理财顾问</a>
              <el-checkbox class="fr checkbox-two" v-model="rememberPsw">记住密码</el-checkbox>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
    <lvFooter></lvFooter>
  </div>
</template>

<script>
import AES from '../../js/AES.js'
import lvFooter from '../../components/lv-footer/lv-footer.vue';
export default {
  name: "login",
  components: {
    lvFooter
  },
  data () {
    var isCode = (rule, value, callback) => {
      const cell = /^(13|15|16|17|18|14|19)\d{9}$/g;
      if ((value.length > 5 && cell.test(value)) || value.length < 5) {
        callback()
      } else {
        callback(new Error('请输入正确的管理账号/手机号'))
      }
    };
    var isPass = (rule, value, callback) => {
      const reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(value)) {
        callback('密码不能为汉字')
      } else if (value.length < 6 || value.length > 8) {
        callback(new Error('密码长度在6-8之间'))
      } else {
        callback()
      }
    };
    return {
      loginForm: {
        code: '',
        pass: ''
      },
      passErrorMsg: '',
      phoneErrorMsg: '',
      loginFormRules: {
        code: [

          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: isCode, trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { validator: isPass, trigger: 'blur' }
        ],
      },
      rememberPsw: false,
      manage:false //管理员登录
    }
  },
  created () {
    // 在页面加载时从cookie获取登录信息
    let Login = this.$commonJs.getCookie("Login");
    let Password = AES.decrypt(this.$commonJs.getCookie("Password"));
    // 如果存在赋值给表单，并且将记住密码勾选
    if (Login) {
      this.loginForm.code = Login;
      this.loginForm.pass = Password;
      this.rememberPsw = true;
    }
  },
  methods: {
    login () {
      this.passErrorMsg = ''
      this.$refs.loginFormRef.validate(valid => {
        if (!valid) return
        let data = {
          Code: this.loginForm.code,
          Password: this.loginForm.pass
        }
        data.Manager = this.manage? '1':'0'; //管理员1，非管理员0
        this.$http.post(this.$apiPath.login, data).then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.setUserInfo();  // 记住密码
            this.$commonJs.setCookie("code", res.data.data.adviserCode, 1);
            this.$commonJs.setCookie("pass", AES.encrypt(this.loginForm.pass), 1);
            this.$commonJs.setCookie("token", res.data.data.adviserGuid, 1);//res.data.data.adviserGuid
            this.$commonJs.setCookie("adviserName", res.data.data.adviserName, 1);
            this.$commonJs.setCookie("adviserPnone", res.data.data.phone, 1);
            this.$commonJs.setCookie("acticePath", "/home", 1);
            this.$commonJs.setCookie("manager", res.data.data.manager, 1);

            // Manager，管理员1，非管理员0
            let name = res.data.data.manager == '1'? 'manageHome':'home';
            this.$router.push({ name: name })
          } else if (res.data.code == 601) {
            this.passErrorMsg = '密码错误'
          } else {
            this.passErrorMsg = res.data.message
          }
        }).catch(err => { })
      })
    },
    setUserInfo () {
      if (this.rememberPsw) {// 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
        this.$commonJs.setCookie("Login", this.loginForm.code, 7);
        let passWord = AES.encrypt(this.loginForm.pass)//加密
        this.$commonJs.setCookie("Password", passWord, 7);
      } else {// 如果没有勾选，储存的信息为空
        this.$commonJs.setCookie("Login", "");
        this.$commonJs.setCookie("Password", "");
      }
    },
    // 用户名enter
    LoginEnter () {
      this.$refs.loginFormRef.validateField('code', (err) => {
        if (err == '') {
          this.phoneErrorMsg = err
          this.$refs.psdRef.focus()
        }
      })
    },
    //密码enter
    PwdEnter () {
      this.$refs.loginFormRef.validateField('pass', (err) => {
        this.passErrorMsg = err
      })
      if (this.passErrorMsg != '') {
        return
      } else if (this.phoneErrorMsg != '' || this.loginForm.code.trim() == '') {//账户错误或者账户为空
        this.$refs.loginRef.focus()
      } else {
        this.login();
      }
    },
  }
}
</script>

<style lang="less">
.loginCon {
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 653px;
  background: url(../../assets/images/login1.png) no-repeat;
  background-size: auto 100%;
  background-position: center;
  overflow: hidden;
  &-box {
    margin-top: 80px;
    height: 490px;
    text-align: center;
    &-left {
      width: 800px;
      height: 100%;
      background: @colorbg3;
      opacity: 0.9;
      color: @wColor;
    }
    &-right {
      box-sizing: border-box;
      width: calc(100% - 800px);
      height: 100%;
      background: @wColor;
      padding: 45px;
    }
    &-tit {
      font-size: 58px;
      font-weight: bold;
      margin-top: 125px;
      text-shadow: 5px 2px 5px @bColor;
      letter-spacing: 8px;
    }
    &-ul {
      margin: 0 58px;
      font-size: 20px;
      li {
        float: left;
        width: 211px;
        height: 52px;
        background: rgba(0, 0, 0, 0.17);
        margin-right: 25px;
        border-radius: 10px;
        line-height: 52px;
        text-shadow: 2px 2px 2px @bColor;
        letter-spacing: 2px;
        img {
          margin: -4px 12px 0 0;
        }
      }
      li:last-child {
        margin-right: 0;
      }
    }
    &-loginTit {
      font-size: 22px;
      color: @color6;
      margin: 70px 0 36px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      >span{
        width:49%;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
      }
      >span:nth-child(2){
        width:1px;
        text-align: center;
        font-weight: 300;
        color:@oColor13;
        height:20px;
        border-right:1px solid @oColor13;
      }
      .active{
        color:@colorLogin;
        font-weight: bold;
      }

    }
  }
}
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus {
  border-color: @oColor13;
}
.el-input--prefix .el-input__inner {
  border-color: @oColor13;
}
</style>

